exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".motivation{margin:10px;margin-bottom:64px;text-align:center;display:flex;flex-direction:column;align-items:center}.motivation img{margin-top:16px;border:4px solid #62b46d}.motivation .checkbox{margin-top:64px}.motivation .checkbox .title{width:initial;font-size:14px;color:#72ca7e}.motivation .checkbox .controls{width:initial}", ""]);

